import {PageModel, Project, ProjectAPI, Tag, TeamAPI, GetProjectsByFilterProps, Factory} from '@brg/api';

import { useAPIMethodArray } from '../useAPIMethodArray';
import { useAPIMethod } from '../useAPIMethod';

const getOtherProjectsForTag = Factory.createGetMethodExtended(
  ProjectAPI,
  '/api/project/GetOtherProjectsForTag',
);

export const useProjectsByFilter = (request: GetProjectsByFilterProps, lang = 'en', t?: number) =>
  useAPIMethodArray<Project, any>(ProjectAPI.GetProjectsByFilter, request, lang, t);

const getProjectsMethod = (
  isTeamProjects?: boolean,
  withOtherProjects?: boolean,
  useListLiteModal?: boolean
) => {
  if (withOtherProjects) return ProjectAPI.GetListForAuthorIdsAndProjectIds;
  if (isTeamProjects)    return TeamAPI.GetPending;
  if (useListLiteModal)  return ProjectAPI.GetListLiteModal;
  return ProjectAPI.GetList;
};

export const useProjectsList = (
  request: GetProjectsByFilterProps | null,
  lang = 'en',
  t?: number,
  disabled?: boolean,
  isTeamProjects?: boolean,
  withOtherProjects?: boolean,
  setIsLoadingExt?: any,
  useListLiteModal?: boolean
) =>
  useAPIMethod<PageModel<Project>, any>(
    getProjectsMethod(isTeamProjects, withOtherProjects, useListLiteModal),
    request,
    lang,
    t,
    disabled,
    setIsLoadingExt
  );

export const useGetProjectTags = (request: GetProjectsByFilterProps | null, lang = 'en', t?: number, disabled?: boolean) =>
  useAPIMethod<Tag[], any>(ProjectAPI.GetProjectTags, request, lang, t, disabled);

export const useTagsProjects = (request: any, lang = 'en', t?: number) =>
  useAPIMethodArray<Tag, any>(ProjectAPI.GetTagsProjects, request, lang, t);

export const useOtherProjectsForTagList = (
  request: GetProjectsByFilterProps | null,
  lang = 'en',
  t?: unknown,
  disabled?: boolean,
) =>
  useAPIMethod<PageModel<Project>, any>(
    getOtherProjectsForTag,
    request,
    lang,
    t,
    disabled,
  );
import {PageModel, Project, ProjectAPI, Tag, TeamAPI, GetProjectsByFilterProps, Factory} from '@brg/api';

import { useAPIMethodArray } from '../useAPIMethodArray';
import { useAPIMethod } from '../useAPIMethod';

const getOtherProjectsForTag = Factory.createGetMethodExtended(
  ProjectAPI,
  '/api/project/GetOtherProjectsForTag',
);

export const useProjectsByFilter = (request: GetProjectsByFilterProps, lang = 'en', t?: number) =>
  useAPIMethodArray<Project, any>(ProjectAPI.GetProjectsByFilter, request, lang, t);

const getProjectsMethod = (
  isTeamProjects?: boolean,
  withOtherProjects?: boolean,
  useListLiteModal?: boolean
) => {
  if (withOtherProjects) return ProjectAPI.GetListForAuthorIdsAndProjectIds;
  if (isTeamProjects)    return TeamAPI.GetPending;
  if (useListLiteModal)  return ProjectAPI.GetListLiteModal;
  return ProjectAPI.GetList;
};

export const useProjectsList = (
  request: GetProjectsByFilterProps | null,
  lang = 'en',
  t?: number,
  disabled?: boolean,
  isTeamProjects?: boolean,
  withOtherProjects?: boolean,
  setIsLoadingExt?: any,
  useListLiteModal?: boolean
) =>
  useAPIMethod<PageModel<Project>, any>(
    getProjectsMethod(isTeamProjects, withOtherProjects, useListLiteModal),
    request,
    lang,
    t,
    disabled,
    setIsLoadingExt
  );

export const useGetProjectTags = (request: GetProjectsByFilterProps | null, lang = 'en', t?: number, disabled?: boolean) =>
  useAPIMethod<Tag[], any>(ProjectAPI.GetProjectTags, request, lang, t, disabled);

export const useTagsProjects = (request: any, lang = 'en', t?: number) =>
  useAPIMethodArray<Tag, any>(ProjectAPI.GetTagsProjects, request, lang, t);

export const useOtherProjectsForTagList = (
  request: GetProjectsByFilterProps | null,
  lang = 'en',
  t?: unknown,
  disabled?: boolean,
) =>
  useAPIMethod<PageModel<Project>, any>(
    getOtherProjectsForTag,
    request,
    lang,
    t,
    disabled,
  );
